import React from 'react';
import { FaUserFriends, FaChartLine, FaCalendarCheck, FaDumbbell, FaFingerprint, FaCashRegister } from 'react-icons/fa';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <div className="bg-white rounded-xl shadow-md p-6 transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1 border border-gray-100">
      <div className="text-blue-600 mb-4 text-3xl">{icon}</div>
      <h3 className="text-xl font-semibold mb-3 text-gray-900">{title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
    </div>
  );
};

const Features: React.FC = () => {
  const features = [
    {
      icon: <FaFingerprint />,
      title: "Control Biométrico por Huella & QR",
      description: "Sistema de acceso híbrido por lector de huellas dactilares y código QR para un ingreso ágil, seguro y sin fraudes en molinetes y recepción."
    },
    {
      icon: <FaCalendarCheck />,
      title: "Control de Asistencias en Tiempo Real",
      description: "Monitorea la frecuencia de tus socios al instante y valida automáticamente si su membresía se encuentra al día o vencida."
    },
    {
      icon: <FaCashRegister />,
      title: "Caja Diaria & Pagos Integrados",
      description: "Gestiona los cobros de membresías, ingresos varios y gastos operativos con reportes diarios y balances netos instantáneos."
    },
    {
      icon: <FaUserFriends />,
      title: "Gestión Integral de Socios",
      description: "Administra fichas médicas, estados de cuenta, historial de asistencias y preferencias de tus socios en un solo lugar."
    },
    {
      icon: <FaChartLine />,
      title: "Reportes Financieros & Métricas",
      description: "Estadísticas en tiempo real de ingresos por actividad, retención de clientes y tendencias para tomar mejores decisiones."
    },
    {
      icon: <FaDumbbell />,
      title: "Rutinas & Planes de Entrenamiento",
      description: "Crea y asigna rutinas personalizadas a tus socios con catálogo global de ejercicios e instructivos detallados."
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Características Principales
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            MultiGym ofrece todas las herramientas necesarias para digitalizar y escalar la gestión de tu gimnasio de manera moderna y segura.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;